<template>

  <div>
    <!-- Query conditioner -->
    <el-row :gutter="10">
      <el-card shadow="never">
        <!-- Date range picker -->
        <el-col :xs="24" :sm="24" :md="10" :lg="10">
            <div class="d-flex justify-space-between">
              <date-range-picker :from="queryParams.from" :to="queryParams.to" @on-change="applyDateRange"
                  :shortcuts="dateRangeShortcuts" :earliest="dateRangePickerEarliest"></date-range-picker>
              <!-- <el-date-picker type="daterange" v-model="pickedDates"
                range-separator="～" start-placeholder="開始日期" end-placeholder="結束日期"
                :picker-options="datePickerOptions">
              </el-date-picker>  -->
            </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="4" :lg="4">
          <div class="d-flex justify-space-between">
            <AccountFinder @account-selected="onAccountSelected" ></AccountFinder>  
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="4" :lg="4">
          <div class="d-flex justify-space-between">
            <ShopFinder @shop-selected="onShopSelected" :baId="queryParams.accountId"></ShopFinder>  
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6" :lg="6">
          <div class="d-flex justify-space-between">
            <el-input placeholder="（搜尋交易編號）" v-model="queryParams.orderId"
                maxlength="40" clearable>
            </el-input>   
            <el-button slot="append" @click="onSearchClick">查詢</el-button>
       
          </div>
        </el-col>
        <el-col :span="24">
          <div class="d-flex" style="margin-top:10px">
            <!-- exports -->
            <el-button round type="danger" icon="now-ui-icons arrows-1_cloud-download-93" @click="doExport">
              匯出報表
            </el-button>
            <br/>

          </div>
        </el-col>
      </el-card>

      <!-- <el-col :span="16"></el-col> -->
    </el-row>
    <br/>
    <el-row :gutter="10">
      <el-col :span="24">
         <data-table ref="table"
          :data="records" :cols="cols" :total="total" :loading="isLoading"
          :on-sort-change="onSortChange" :on-page-request="onPageRequest"
          :rows-per-page-options="[10, 20, 30]" :on-rows-per-page-change="onRowsPerPageChange">

           <div slot="transactionCreatedAt" slot-scope="{row}">
            {{row.transactionCreatedAt | toDateTimeString}}
          </div>
          
          <div slot="amount" slot-scope="{row}">
            <b>
              <i v-if="row.action === 'load' || row.action === 'rebate' || row.action === 'reward'  || row.action === 'refund'" class="el-icon-plus"></i>
              <i v-else class="el-icon-minus"></i>
              {{Number(row.amount).toLocaleString()}}
            </b>
          </div>


          <div slot="action" slot-scope="{row}">
            <span v-if="row.action === 'load'">儲值</span>
            <span v-else-if="row.action === 'redeem'">使用儲值金</span>
            <span v-else-if="row.action === 'refund'">退回儲值金</span>
            <span v-else-if="row.action === 'cancel'">取消儲值</span>
            <span v-else-if="row.action === 'reward'">贈送點數</span>
            <span v-else-if="row.action === 'rebate'">系統儲值</span>
            <span v-else> {{row.action}} </span>
          </div>

          <div slot="type" slot-scope="{row}">
            <span v-if="row.type === 'sms'">簡訊費</span>
            <span v-else-if="row.type === 'git'">物流費</span>
            <span v-else-if="row.type === 'git-cs'">款項異動</span>
            <span v-else-if="row.type === 'git-cs-rebate'">款項異動</span>
            <span v-else-if="row.type === 'sms-cs-rebate'">款項異動</span>
            <span v-else> {{row.type}} </span>
          </div>
          
          <!-- <div slot="Actions" slot-scope="{row}">
            <el-button type="primary" icon="el-icon-info" circle size="small" @click="showDetail(row)"></el-button>
          </div> -->
        </data-table>
      </el-col>
    </el-row>
    <!-- Dialog of order detail -->
    <!-- <DepositRecordDetail :show.sync="dialog.detail.show" :order-id="dialog.detail.orderId" :ba-id="dialog.detail.baId">
    </DepositRecordDetail> -->
    <br/>
  </div>
</template>

<script>
import {
  Button
} from 'element-ui';
import DateRangePicker from 'src/components/DateRangePicker';
import {Modal} from 'src/components';
import DataTable from 'src/components/DataTable';
import AccountFinder from './AccountFinder.vue';
import ShopFinder from './ShopFinder.vue';

// import DepositRecordDetail from './DialogDepositRecordDetail.vue'; 

import { UserInfoMixin } from 'src/mixins/user-info.js';

import axios from 'axios';
import moment from 'moment';

export default {
  components: {
    [Button.name]: Button,
    DateRangePicker,
    Modal,
    DataTable,
    AccountFinder,
    ShopFinder
    // DepositRecordDetail
  },
  mixins: [ UserInfoMixin ],

  mounted() {
    this.fetchRecords();
  },

  methods: {
    fetchRecords() {
      console.warn(`[DEPOSIT-RECORDS] Querying deposit records by...`, this.queryParams);
      this.isLoading = true;

      // Resolve some query arguments.
      let fromMoment = moment(this.queryParams.from);
      let toMoment = moment(this.queryParams.to);
      if (toMoment.diff(fromMoment, 'days') > 31) {
        alert(`查詢日期區間最多一個月（31日）!`);
        this.isLoading = false;
        return;
      }
      
      // Compose query URL.
      // let apiHost = 'https://apis-dev.ddc.ai/vas/v1/merchants/ddcstore/management/transactions';
      let apiHost = `${process.env.VUE_APP_APIHOST}/${this.userType}/vas/merchants/ddcstore/transactions`;
      // let apiHost = 'http://localhost:3000/vas/v1/merchants/ddcstore/management/transactions';
      let url = `${apiHost}?startIndex=${this.queryParams.startIndex}&limit=${this.queryParams.limit}`;
      // let url = `${process.env.VUE_APP_APIHOST}/${this.userType}/orders?dateType=ts&joinShopNames=true&includeNotes=true&includeStatus=true`
      //     + `&startIndex=${this.queryParams.startIndex}&limit=${this.queryParams.limit}`
      //     + (this.queryParams.sort? `&sort=${this.queryParams.sort}`: '');

    
      //Common search
      url += 
          // Time range
          `&from=${fromMoment.unix()}&to=${toMoment.unix()}`
          + (this.queryParams.timeBased !== 'created_at'? `&timeRangeAttr=${this.queryParams.timeBased}`: '')
          + (this.queryParams.accountId ? `&baId=${this.queryParams.accountId}`: '')
          + (this.queryParams.shopId ? `&shopId=${this.queryParams.shopId}`: '')
          + (this.queryParams.orderId ? `&merchantOrderId=${this.queryParams.orderId}`: '')
        ;

      // Make actual request.
      axios.get(url)
      .then(response => {
        console.log(`[DEPOSIT-TRANSACTIONS] Deposit transactions fetched`, response.data);
        this.total = response.data.total;
        this.records = response.data.transactions;
        return;
      })
      .catch(err => {
        console.error(`[DEPOSIT-TRANSACTIONS] Cannot fetch list`, err);
        let errMessage;
        if (err.data && err.data && err.data.code) {
          if (err.data.code == 'TRAN001') {
            this.total = 0;
            this.records = [];
            return;
          }
          else if (err.data.code == 'PROTOCOL_SEQUENCE_TIMEOUT')
            errMessage = '資料庫查詢請求逾時！建議縮小查詢範圍。';
          else
            errMessage = err.data.message
        }
        this.$notify.error({
          title: '查詢錯誤',
          message: errMessage
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
    },
    doExport() {
      // Resolve some query arguments.
      let fromMoment = moment(this.queryParams.from);
      let toMoment = moment(this.queryParams.to);
      if (toMoment.diff(fromMoment, 'days') > 31) {
        alert(`匯出日期區間最多一個月（31日）!`);
        return;
      }
      let fromTs = fromMoment.unix(), toTs = toMoment.unix();
      if (isNaN(fromTs) || isNaN(toTs)) {
        alert(`所選日期有誤！`);
        return;
      }
       
      // let apiHost = 'https://apis-dev.ddc.ai/vas/v1/merchants/ddcstore/management/transactions/export';
      let apiHost = `${process.env.VUE_APP_APIHOST}/${this.userType}/vas/merchants/ddcstore/transactions/export`;

      // let apiHost = 'http://localhost:3000/vas/v1/merchants/ddcstore/management/transactions/export';
      // let url = `${apiHost}?from=${fromMoment.unix()}&to=${toMoment.unix()}`;
      // url +=  (this.queryParams.accountId ? `&baId=${this.queryParams.accountId}`: '');
      let data = {
        from: fromMoment.unix(),
        to: toMoment.unix(),
      }
      if (this.queryParams.accountId) data.baId = this.queryParams.accountId;
      if (this.queryParams.shopId) data.shopId = this.queryParams.shopId;
      if (this.queryParams.orderId) data.merchantOrderId = this.queryParams.orderId;
      axios.request({
        method: "get",
        responseType: "blob",
        url: `${apiHost}`,
        params: data
      })
      .then(response => {
        console.log(`[DEPOSIT-TRANSACTIONS] Deposit transactions export`);
        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          `deposit-transactions-${new Date().getTime()}.xlsx`
        );
        document.body.appendChild(fileLink);

        fileLink.click();
        window.URL.revokeObjectURL(fileLink);
      })

    },

    applyDateRange(dates) {
      this.queryParams.isDefaultDateRange = false;
      this.queryParams.from = dates[0];
      this.queryParams.to = dates[1];

      //FIXME: Reset limit-offset.
      this.queryParams.startIndex = 0;
      this.fetchRecords();
    },

    onAccountSelected(accountId, accountName) {
      this.queryParams.accountId = accountId || 0;
      this.queryParams.shopId = undefined;
      // Reset limit-offset and search inputs.
      this.queryParams.startIndex = 0;
      this.fetchRecords();
    },
    onShopSelected(shopId, shopName) {
      this.queryParams.shopId = shopId || undefined;
      // Reset limit-offset and search inputs.
      this.queryParams.startIndex = 0;
      this.fetchRecords();
    },
    onSortChange({prop, key, order}) {
      // console.warn('[ORDERS] DataTable: onSortChange', prop, key, order);
      let ordering = order === 'ascending'? 'asc': 'desc';
      this.queryParams.sort = `${prop}:${ordering}`;
      this.fetchRecords();
    },
    onPageRequest(page) {
      // console.warn(`[ORDERS] DataTable: Trying to fetch page ${page}...`);
      this.queryParams.startIndex = (page - 1) * this.queryParams.limit;
      this.fetchRecords();
    },
    onRowsPerPageChange(rpp) {
      this.queryParams.limit = rpp;
      this.queryParams.startIndex = 0;
      this.fetchRecords();
    },
    onSearchClick() {
      this.queryParams.startIndex = 0;
      this.fetchRecords();
    },
    showDetail(data) {
      this.dialog.detail.orderId = data.depositOrderId;
      this.dialog.detail.baId = data.billingAccountId;
      this.dialog.detail.show = true;
    }
  },

  data() {
    return {
      records: [],
      total: 0,//FIXME: To be updated.
      isLoading: false,

      dateRangeShortcuts: [
        {
          label: '今日',
          from: moment().startOf('day').toDate(),
          // to: new Date()
        },
        {
          label: '昨日',
          from: moment().add(-1, 'days').startOf('day').toDate(),
          to: moment().add(-1, 'days').endOf('day').toDate()
        },
        {
          label: '本週',
          from: moment().startOf('isoWeek').toDate(),
          // to: new Date()
        },
        {
          label: '上週',
          from: moment().add(-1, 'week').startOf('isoWeek').toDate(),
          to: moment().add(-1, 'week').endOf('isoWeek').toDate(),
        },
        {
          label: '本月',
          from: moment().startOf('month').toDate(),
          // to: new Date()
        },
        {
          label: '上個月',
          from: moment().add(-1, 'month').startOf('month').toDate(),
          to: moment().add(-1, 'month').endOf('month').toDate(),
        }
      ],

      queryParams: {
        from: moment().startOf('day').toDate(),
        to: new Date(),
        timeBased: 'created_at',

        startIndex: 0,
        limit: 10,
        
        accountId: undefined,
        shopId: undefined,
      },

      cols: [
        {prop: 'billingAccountId', key: 'billingAccountId', label: '帳戶ID', width: 130, sortable: false},
        {prop: 'billingAccountName', key: 'billingAccountName', label: '帳戶名稱', sortable: false},
        {prop: 'shopId', key: 'shopId', label: '商店ID', width: 130, sortable: false},
        // {prop: 'shopName', key: 'shopName', label: '商店名稱', sortable: false},
        {prop: 'transactionCreatedAt', key: 'transactionCreatedAt', label: '交易時間', sortable: false},
        {prop: 'merchantOrderId', key: 'merchantOrderId', label: '交易編號', width: 150, sortable: false},
        {prop: 'action', key: 'action', label: '交易類型', sortable: false},
        {prop: 'remark', key: 'remark', label: '備註', sortable: false},
        {prop: 'type', key: 'type', label: '使用項目', sortable: false},
        {prop: 'amount', key: 'amount', label: '點數', align:'center', sortable: false},
        {prop: 'Actions', key: '', label: '', width: 72}
      ],

      dialog: {
        detail: {
          show: false,
          orderId: null,
          baId: null
        }
      },

    };
  },

  computed: {
    user() {
      return this.$store.getters.user;
    },
    userType() {
      return this.$store.getters.userType;
    },

    dateRangePickerEarliest() {
      if (this.userType === 'gaa') return 0;
      return moment().add(-3, 'months').startOf('day').unix();
    },

  },

  filters: {
    toDateTimeString(ts) {
      return ts ? moment.unix(ts).format('YYYY/M/D h:mmA') : '';
    },
  }
};
</script>

<style scoped>
i.el-icon-success {color: green; font-size: 20px;}
i.el-icon-remove {color: red; font-size: 20px;}

.row > .col,
.row > [class*="col-"] {
  padding-left: 5px;
  padding-right: 5px;
}
</style>